import React from 'react';
import { Card } from 'react-bootstrap';

import Table from '../table';
import Pagination from '../../components/pagination';

const TableCombination = ({ header, body, bordered, totalCount, presetSelect, presetContent, selectHandler }) => {
    return (
        <React.Fragment>
            <Card className='table-combination mb-4 p-3'>
                <Table header={ header } body={ body } bordered={ bordered } presetSelect={ presetSelect } presetContent={ presetContent } selectHandler={ selectHandler } />
            </Card>
            { totalCount > 0 && <Pagination totalCount={ totalCount } /> }
        </React.Fragment>
    );
};

export default React.memo(TableCombination);